import React from 'react';
import useTranslation from '../../hooks/useTranslation';
import styles from './LanguageToggle.module.css';

const LanguageToggle: React.FC = () => {
    const { language, setLanguage } = useTranslation();

    const handleLanguageChange = (lang: 'en' | 'sv') => {
        setLanguage(lang);
    };

    return (
        <div className={styles.languageToggle}>
            <button 
                className={language === 'en' ? styles.active : ''} 
                onClick={() => handleLanguageChange('en')}
                title="English"
            >
                <span className={styles.fullLabel}>English</span>
                <span className={styles.shortLabel}>EN</span>
            </button>
            <button 
                className={language === 'sv' ? styles.active : ''} 
                onClick={() => handleLanguageChange('sv')}
                title="Svenska"
            >
                <span className={styles.fullLabel}>Svenska</span>
                <span className={styles.shortLabel}>SV</span>
            </button>
        </div>
    );
};

export default LanguageToggle;